/* eslint-disable no-use-before-define */
/* eslint-disable no-else-return */
import { useMemo } from 'react';
import _ from 'underscore';

export default function useDataRestrictions(restrictions) {
  return useMemo(() => ({
    ...timeZoneDataManagement(restrictions.timeZoneByCountry),
    ...phoneDataManagement(restrictions.phoneByCountry),
    ...countryDataManagement(restrictions.countries),
    ...currencyDataManagement(restrictions.currencies),
    ...currencyCountriesMappingDataManagement(restrictions.currencyCountriesMapping),
    ...subGeographyDataManagement(restrictions.subGeography),
    ...accountDataManagement(restrictions.account),
    ...userAddressSubGeographyDataManagement(restrictions.userAddressSubGeography),
    ...addressDataManagement(restrictions.address),
  }), [restrictions.timeZoneByCountry, restrictions.phoneByCountry, restrictions.countries, restrictions.currencies, restrictions.currencyCountriesMapping, restrictions.subGeography, restrictions.account, restrictions.userAddressSubGeography, restrictions.address]);
}

function timeZoneDataManagement(timeZoneFilter) {
  // NOTE: timezone filtering by country is the default; to disable it, we need to pretend we don't have any timezone-to-country mapping data
  // set timeZonesPerCountryMapping to empty
  if (!timeZoneFilter) {
    return {};
  } else if (_.isFunction(timeZoneFilter)) {
    return {
      timeZones: {
        // the function will receive the original list of timezones,
        // and it's expected to return the filtered list, or a promise with that list
        callback: timeZoneFilter,
      },
      timeZonesPerCountryMapping: {
        dataFetch: () => Promise.resolve([]),
      },
    };
  } else {
    return {
      timeZones: {
        // in this case, the "filter" is expected to be
        // either the list of supported timezones, or a promise with that list
        dataFetch: () => Promise.resolve(timeZoneFilter),
      },
      timeZonesPerCountryMapping: {
        dataFetch: () => Promise.resolve([]),
      },
    };
  }
}

function phoneDataManagement() {
  return {};
}

function countryDataManagement(countryFilter) {
  if (!countryFilter) {
    return {};
  } else if (_.isFunction(countryFilter)) {
    return {
      countries: {
        // the function will receive the original list of countries,
        // and it's expected to return the filtered list, or a promise with that list
        callback: countryFilter,
      },
    };
  } else {
    return {
      countries: {
        // in this case, the "filter" is expected to be
        // either the list of supported countries, or a promise with that list
        dataFetch: () => Promise.resolve(countryFilter),
      },
    };
  }
}

function currencyDataManagement(currencyFilter) {
  if (!currencyFilter) {
    return {};
  } else if (_.isFunction(currencyFilter)) {
    return {
      currencies: {
        // the function will receive the original list of currencies,
        // and it's expected to return the filtered list, or a promise with that list
        callback: currencyFilter,
      },
    };
  } else {
    return {
      currencies: {
        // in this case, the "filter" is expected to be
        // either the list of supported currencies, or a promise with that list
        dataFetch: () => Promise.resolve(currencyFilter),
      },
    };
  }
}

function currencyCountriesMappingDataManagement(mappingData) {
  if (!mappingData) {
    return {};
  }
  return {
    currencyCountriesMapping: {
      dataFetch: () => Promise.resolve(mappingData),
    },
  };
}

function subGeographyDataManagement(subGeographyFilter) {
  if (!subGeographyFilter) {
    return {};
  } else if (_.isFunction(subGeographyFilter)) {
    return {
      subGeography: {
        // the function will receive the original list of subGeography,
        // and it's expected to return the filtered list, or a promise with that list
        callback: subGeographyFilter,
      },
    };
  } else {
    return {
      subGeography: {
        // in this case, the "filter" is expected to be
        // either the list of supported subGeography, or a promise with that list
        dataFetch: () => Promise.resolve(subGeographyFilter),
      },
    };
  }
}

function accountDataManagement(accountData) {
  if (!accountData) {
    return {};
  }
  return {
    account: {
      dataFetch: () => Promise.resolve(accountData),
    },
  };
}

function userAddressSubGeographyDataManagement(subGeographyData) {
  if (!subGeographyData) {
    return {};
  }
  return {
    userAddressSubGeography: {
      dataFetch: () => Promise.resolve(subGeographyData),
    },
  };
}

function addressDataManagement(addressOverride) {
  if (!addressOverride) {
    return {};
  } else if (_.isFunction(addressOverride)) {
    return {
      address: {
        dataFetch: addressOverride,
      },
    };
  } else {
    return {
      address: {
        dataFetch: () => Promise.resolve(addressOverride),
      },
    };
  }
}
